import React from 'react';
import { Skeleton, TableCell, TableRow } from '@mui/material';

export interface JobOpeningsTableSkeletonProps {
  rowCount?: number;
}

export const JobOpeningsTableSkeleton = ({ rowCount = 5 }: JobOpeningsTableSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, index) => (
        <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
          <TableCell align="left">
            <Skeleton variant="text" width={180} height={24} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="rounded" width={100} height={24} sx={{ borderRadius: 1 }} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" width={120} height={20} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" width={120} height={20} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="rounded" width={50} height={24} sx={{ borderRadius: 1 }} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" width={90} height={20} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" width={90} height={20} />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="rounded" width={140} height={22} sx={{ borderRadius: 3 }} />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
